import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

import {
  BSC_MAINNET,
  MANTLE_MAINNET,
  ARBITRUM,
  CHAIN_ID_MAPPING,
  THIRD_PARTY_EXCHANGE_CLIENT_MAP,
} from "../constants";

const S3_DOMAIN = "https://storage.googleapis.com/ktx-data";

export const SUBGRAPH_CATEGORY_KEY = {
  TRADE: "trade",
  STATS: "stats",
  OTHER: "other",
};

const SUBGRAPH_URLS = {
  [CHAIN_ID_MAPPING[BSC_MAINNET]]: {
    [SUBGRAPH_CATEGORY_KEY.TRADE]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/bsc_trade/api",
    [SUBGRAPH_CATEGORY_KEY.STATS]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/bsc_stats/api",
    [SUBGRAPH_CATEGORY_KEY.OTHER]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/bsc_other/api",
  },
  [CHAIN_ID_MAPPING[MANTLE_MAINNET]]: {
    [SUBGRAPH_CATEGORY_KEY.TRADE]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/mantle_trade/api",
    [SUBGRAPH_CATEGORY_KEY.STATS]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/mantle_stats/api",
    [SUBGRAPH_CATEGORY_KEY.OTHER]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/mantle_other/api",
  },
  [CHAIN_ID_MAPPING[ARBITRUM]]: {
    [SUBGRAPH_CATEGORY_KEY.TRADE]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/ktx_trade/api",
    [SUBGRAPH_CATEGORY_KEY.STATS]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/ktx_stats/api",
    [SUBGRAPH_CATEGORY_KEY.OTHER]:
      "https://subgraph.satsuma-prod.com/dff088b6cd75/kesters-team/ktx_other/api",
  },
};

const graphClientMap = {};

const getGraphUrl = (
  res,
  chainId,
  categoryKey = SUBGRAPH_CATEGORY_KEY.STATS
) => {
  return res?.[chainId]?.[categoryKey] ?? SUBGRAPH_URLS[chainId][categoryKey];
};

export function createGraphClient(uri) {
  return new ApolloClient({
    connectToDevTools: true,
    uri,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
      },
    },
  });
}

export const getSwapClient = async (chainId) => {
  const res = await createGraphClient(THIRD_PARTY_EXCHANGE_CLIENT_MAP[chainId]);
  return res;
};

export const getGraphClientMap = async (chainName, clientCategoryKey) => {
  const chainId = CHAIN_ID_MAPPING[chainName];
  if (graphClientMap[chainId]) {
    return graphClientMap[chainId][clientCategoryKey];
  }
  const graphUrl = `${S3_DOMAIN}/subgraph_url_v2.json`;

  const res = await fetch(graphUrl, {
    method: "GET",
    cache: "no-cache",
  })
    .then((res) => res.json())
    .catch(console.error);

  for (const chainId of Object.keys(res)) {
    graphClientMap[chainId] = {};
    for (const categoryKey of Object.keys(res[chainId])) {
      graphClientMap[chainId][categoryKey] = createGraphClient(
        getGraphUrl(res, chainId, categoryKey)
      );
    }
  }
  return graphClientMap[chainId][clientCategoryKey];
};
